



//======== локальная ==========
import focusable from "./_Focusable"
//=========== npm ==============
//import {focusable} from "cursor-focus"

export default focusable;